/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import apiLimitsFieldsetTemplate from './api-limits-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

import './api-limits.scss';

/*@ngInject*/
export default function ApiLimitsDirective($compile, $templateCache, types) {
    var linker = function (scope, element) {
        var template = $templateCache.get(apiLimitsFieldsetTemplate);
        element.html(template);
        scope.types = types;
        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            apiLimits: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/api-limits/api-limits.directive.js